/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Products',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/products'
    }
];

// ============================================================
// Helpers — قراءة الصلاحيات من التوكن
// ============================================================

function decodeToken(): any | null {
    try {
        const token = localStorage.getItem('accessToken') ?? '';
        if (!token) return null;

        const parts = token.split('.');
        if (parts.length !== 3) return null;

        const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64.padEnd(
            base64.length + (4 - (base64.length % 4)) % 4,
            '='
        );

        const decoded = decodeURIComponent(
            atob(padded)
                .split('')
                .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );

        return JSON.parse(decoded);
    } catch {
        return null;
    }
}

function getPermissionsFromToken(): string[] {
    const payload = decodeToken();
    if (!payload) return [];

    const permission = payload.permission;
    if (Array.isArray(permission)) return permission;
    if (typeof permission === 'string') return [permission];
    return [];
}

function has(permission: string): boolean {
    return getPermissionsFromToken().includes(permission);
}

// ============================================================
// ✅ Function — بتتحسب كل مرة تنادي عليها
// ============================================================

export function buildCompactNavigation(): FuseNavigationItem[] {

    const nav: FuseNavigationItem[] = [];

    nav.push({
        id: 'Dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:chart-bar',
        link: '/home'
    });

    nav.push({
        id: 'products',
        title: 'Products',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/admin/products'
    });

    nav.push({
        id: 'categories',
        title: 'Categories',
        type: 'basic',
        icon: 'heroicons_outline:tag',
        link: '/admin/categories'
    });

    nav.push({
        id: 'brands',
        title: 'Brands',
        type: 'basic',
        icon: 'heroicons_outline:cube-transparent',
        link: '/admin/brands'
    });

    nav.push({
        id: 'units',
        title: 'Units',
        type: 'basic',
        icon: 'heroicons_outline:inbox-stack',
        link: '/admin/units'
    });

    nav.push({
        id: 'variants',
        title: 'Variants',
        type: 'basic',
        icon: 'heroicons_outline:lifebuoy',
        link: '/admin/variants'
    });

    // Users + Custom Users
    //if (has('Users.View')) {
        nav.push({
           id: 'users',
            title: 'Users',
            type: 'basic',
            icon: 'heroicons_outline:users',
            link: '/admin/users'
        });

      //  nav.push({
      //      id: 'CustomUsers',
       //     title: 'Custom Users',
      //      type: 'basic',
      //      icon: 'heroicons_outline:users',
      //      link: '/admin/custom-users'
      //  });
    //}

    nav.push({
        id: 'orders',
        title: 'Orders',
        type: 'basic',
        icon: 'heroicons_outline:shopping-cart',
        link: '/admin/orders'
    });

    nav.push({
        id: 'reservations',
        title: 'Reservations',
        type: 'basic',
        icon: 'heroicons_outline:bookmark-square',
        link: '/admin/reservations'
    });

    nav.push({
        id: 'MenuDays',
        title: 'MenuDays',
        type: 'basic',
        icon: 'heroicons_outline:arrow-down-tray',
        link: '/admin/MenuDays'
    });

    nav.push({
        id: 'Gallary',
        title: 'Gallary',
        type: 'basic',
        icon: 'heroicons_outline:photo',
        link: '/admin/gallery'
    });

    nav.push({
        id: 'Banners',
        title: 'Banners & Sliders',
        type: 'basic',
        icon: 'heroicons_outline:film',
        link: '/admin/banners'
    });

    nav.push({
        id: 'Settings',
        title: 'Settings',
        type: 'basic',
        icon: 'heroicons_outline:cog-6-tooth',
        link: '/admin/settings'
    });

    // Roles
    if (has('Roles.View')) {
        nav.push({
            id: 'Roles',
            title: 'Roles & Permissions',
            type: 'basic',
            icon: 'heroicons_outline:shield-check',
            link: '/admin/roles'
        });
    }

    return nav;
}